// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__3UGHu","bigColWidth":"Table_bigColWidth__Oarxb","biggerColWidth":"Table_biggerColWidth__1cvZX","row":"Table_row__U3JWg","col":"Table_col__2Qa-P"};